<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Attivita" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Codice:</label>
                    <b-form-input v-model="jsonData.codiceAttivita"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Nome:</label>
                    <b-form-input v-model="jsonData.nomeAttivita"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Area:</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idArea" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="nome" :options="areeOptions"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Presidio:</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="idPresidio" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="denominazione" :options="presidiOptions" @change="onChangePresidio"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Diario:</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idDiario" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="nome" :options="diariOptions"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Form:</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idForm" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="titolo" :options="jsonFormOptions">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Durata:</label>
                    <b-form-input v-model="jsonData.durata" type="number" step="1" :disabled="!isDomiciliare"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Descrizione:</label>
                    <b-form-textarea v-model="jsonData.descrizione" no-resize rows="5"></b-form-textarea>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Gruppi Associati:</label>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <div :class="badgeClass(isTuttiChecked)">
                        <b-form-checkbox :checked="isTuttiChecked" name="check-button" @change="onChangeTutti" switch>Tutti</b-form-checkbox>
                    </div>
                </b-col>
                <b-col v-for="tipologiaUtente of gruppi" :key="tipologiaUtente.id" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <div :class="badgeClass(tipologiaUtente.isCheck)">
                        <b-form-checkbox v-model="tipologiaUtente.isCheck" name="check-button" switch>{{ tipologiaUtente.nome }}</b-form-checkbox>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
            <template #header>
                <div style="display: flex">
                    <span style="flex: 1">Dettagli Prestazioni</span>
                    <b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickCaricaNomenclatore">
                        <i class="bi bi-journals"></i>
                        Carica Da Nomenclatore
                    </b-button>
                </div>
            </template>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Codice Prestazione:</label>
                    <b-form-input v-model="jsonData.codicePrestazione"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Descruzione Prestazione:</label>
                    <b-form-input v-model="jsonData.descrizionePrestazione"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Codice Prestazione Agg:</label>
                    <b-form-input v-model="jsonData.codicePrestazioneAgg"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Descruzione Prestazione Agg:</label>
                    <b-form-input v-model="jsonData.descrizionePrestazioneAgg"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Importo Prestazione:</label>
                    <b-form-input v-model="jsonData.importoPrestazione"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <nomenclatore-list-component ref="cmpNomenclatoreListComponent" @selectedPrestazione="onSelectPrestazione"></nomenclatore-list-component>
    </div>
</template>
<script>
import axios from "axios";
import NomenclatoreListComponent from "../../../utility/components/NomenclatoreListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: { NomenclatoreListComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/rsaattivita",
            pathResourceDiari: "/rsadiari",
            pathResourceAree: "/rsaaree",
            pathResourceDynamicForm: "/dynamicform",
            pathResourceTipologiaAttivita: "/rsaattivitatipologiaoperatore",
            pathResourceGruppi: "/gruppi",
            pathResourceUtentePresidio: "/utentipresidi",
            id: "-1",
            isDomiciliare: false,
            tipologia: "",
            jsonData: {
                codiceAttivita: "",
                nomeAttivita: "",
                idArea: "",
                idDiario: "",
                tipologiaOperatore: null,
                idForm: null,
                descrizione: "",
                codicePrestazione: "",
                descrizionePrestazione: "",
                codicePrestazioneAgg: "",
                descrizionePrestazioneAgg: "",
                importoPrestazione: null,
                listaGruppi: [],
            },
            //  isTuttiChecked: null,
            areeOptions: [{ id: "", nomeAttivita: "-Seleziona Area-" }],
            diariOptions: [],
            jsonFormOptions: [],
            tipologiaOperatoreOptions: [],
            gruppi: [],
            presidiOptions: [],
            idPresidio: null,
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        gruppi: {
            handler(listaGruppi) {
                let me = this;
                me.jsonData.listaGruppi = [];
                listaGruppi.forEach((element) => {
                    if (element.isCheck) {
                        me.jsonData.listaGruppi.push({ idSecurityGruppo: element.id, nomeGruppo: element.nome });
                    }
                });
            },
            deep: true,
        },
    },
    computed: {
        isTuttiChecked() {
            let me = this;
            return me.gruppi.length === me.jsonData.listaGruppi.length;
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.tipologia = this.$route.query.tipologia;
        me.isDomiciliare = me.tipologia === "DOMICILIARE";
        me.jsonData = {
            nomeAttivita: "",
            idArea: "",
            idDiario: "",
            tipologiaOperatore: null,
            idForm: null,
            descrizione: "",
            codicePrestazione: "",
            descrizionePrestazione: "",
            codicePrestazioneAgg: "",
            descrizionePrestazioneAgg: "",
            importoPrestazione: null,
            listaGruppi: [],
            tipologia: me.tipologia,
            durata: 0,
        };
        if (localStorage.getItem("presidio")) {
            let presidio = localStorage.getItem("presidio") == "null" ? null : JSON.parse(localStorage.getItem("presidio"));
            me.idPresidio = presidio ? presidio.idPresidio : null;
        }
        me.loadAree();
        me.loadPresidi();
        me.loadDiari();
        me.loadGruppi();
        me.loadDynamicForm();
    },
    methods: {
        badgeClass(selected) {
            return selected ? "sa-badge sa-badge-selected" : "sa-badge";
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            if (me.id === "-1") {
                this.$emit("afterLoadData");
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios
                    .get(link + me.id)
                    .then((response) => {
                        me.jsonData = response.data.data;
                        me.checkGruppiAssociati(me.jsonData);
                        this.$emit("afterLoadData");
                    })
                    .catch(() => {});
            }
        },
        loadAree() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAree;
            axios
                .get(link)
                .then((response) => {
                    // me.rows = response.data.data.recordsNumber;
                    me.areeOptions = response.data.data.list;
                    me.areeOptions.unshift({
                        id: "",
                        nome: "-Seleziona Area-",
                    });
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        loadPresidi() {
            let me = this;
            if (sessionStorage.getItem("user")) {
                let user = JSON.parse(sessionStorage.getItem("user"));
                me.loadDataResources(me.pathResourceUtentePresidio, { idUtente: user.id }, me.resultResponsePresidi, me.resultErrorPresidi);
            }
        },
        resultResponsePresidi(response) {
            let me = this;
            me.presidiOptions = [];
            response.data.data.list.forEach((element) => {
                me.presidiOptions.push({ id: element.idPresidio, denominazione: element.denominazionePresidio });
            });
            me.presidiOptions.unshift({ id: null, denominazione: "- Selezionare presidio -" });
        },
        resultErrorPresidi(error) {
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            this.$bvToast.toast(messaggio, {
                title: "Attenzione",
                variant: "danger",
                solid: true,
            });
        },
        loadDiari() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDiari;
            me.diariOptions = [];
            if (me.idPresidio) {
                let filtro = { idPresidio: me.idPresidio };
                axios
                    .get(link, { params: filtro })
                    .then((response) => {
                        me.diariOptions = response.data.data.list;
                        me.diariOptions.unshift({ id: "", nome: "-Seleziona Diario-" });
                        this.$emit("afterLoadData");
                    })
                    .catch((err) => {
                        this.$emit("afterLoadData");
                        console.log(err);
                    });
            } else {
                this.$bvToast.toast("Selezionare Presidio", { title: "Attenzione", variant: "danger", solid: true });
                me.diariOptions.unshift({ id: "", nome: "- Nessun Diario Disponibile -" });
            }
        },
        loadGruppi() {
            let me = this;
            me.loadDataResources(me.pathResourceGruppi, {}, me.resultResponseGruppi, me.resultErrorGruppi);
        },
        resultResponseGruppi(response) {
            let me = this;
            //me.gruppi = response.data.data;
            response.data.data.forEach((element) => {
                element.isCheck = false;
                me.gruppi.push(element);
            });
            me.loadData();
        },
        resultErrorGruppi(error) {
            console.log(error.response);
        },
        onClickCaricaNomenclatore() {
            let me = this;
            me.$refs.cmpNomenclatoreListComponent.openModal();
        },
        onSelectPrestazione(json) {
            let me = this;
            me.jsonData.codicePrestazione = json.codicePrestazione;
            me.jsonData.codicePrestazioneAgg = json.codicePrestazioneAgg;
            me.jsonData.descrizionePrestazione = json.descrizione;
            me.jsonData.descrizionePrestazioneAgg = json.descrizioneAgg;
            me.jsonData.importoPrestazione = json.importoPrestazione;
        },
        loadDynamicForm() {
            let me = this;
            me.loadDataResources(me.pathResourceDynamicForm, {}, me.resulResponseDynamicForm, me.resulErrorDynamicForm);
        },
        resulResponseDynamicForm(response) {
            let me = this;
            me.jsonFormOptions = [];
            me.jsonFormOptions = response.data.data.list;
            me.jsonFormOptions.unshift({ idForm: null, titolo: "NESSUNO" });
        },
        resulErrorDynamicForm(error) {
            console.log(error);
        },
        checkGruppiAssociati(jsonData) {
            let me = this;
            let setIdGruppi = new Set(jsonData.listaGruppi.map((element) => element.idSecurityGruppo));
            me.gruppi.forEach((gruppo) => {
                gruppo.isCheck = setIdGruppi.has(gruppo.id);
            });
        },
        onChangeTutti(value) {
            let me = this;
            me.gruppi.forEach((element) => {
                //                me.$set(element, "isCheck", value);
                element.isCheck = value;
            });
        },
        onChangePresidio() {
            let me = this;
            me.jsonData.idDiario = "";
            me.loadDiari();
        },
    },
};
</script>
